global.jQuery = global.$ = window.jQuery = require('jquery');
require('jquery.heightLine');
require('slick');
require('toc');
require('gsap');
require('ScrollTrigger');


//SP判定
//----------------------------------------------
function is_range_sp() {
	var clientW = document.documentElement.clientWidth,
		winW = window.innerWidth ? window.innerWidth : ($(window).width() ? $(window).width() : clientW);
	return (winW <= 767) ? true : false;
}
function is_range_tab() {
	var clientW = document.documentElement.clientWidth,
		winW = window.innerWidth ? window.innerWidth : ($(window).width() ? $(window).width() : clientW);
	return (winW >= 768 && winW <= 991) ? true : false;
}

//スムーススクロール
//----------------------------------------------
function smooth_scroll() {
	var $smoothTarget = $('a[href^="#"]');
	$smoothTarget.not('a.noSmooth').on('click', function () {
		var speed = 500;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = 0;
		if (target.length > 0) {
			position = target.offset().top;
			$magazine_header = $(".c-mheader");
			if($magazine_header.length) {
				var header_h = $magazine_header.height();
				position = position - header_h - 30;
			}
		}
		$("html, body").animate({
			scrollTop: position
		}, speed, "swing");
		return false;
	});
}


//アコーディオン
//----------------------------------------------
function accordion() {
	$(".js-accordion").click(function(eo){
		eo.preventDefault();
		$(this).toggleClass("is-active");
		var target = $(this).attr("data-target");
		$(target).slideToggle();
		var toggleTxt = $(this).attr("data-toggletxt");
		if(toggleTxt.length) {
			var oldTxt = $(this).find("span").text();
			$(this).attr("data-toggletxt",oldTxt).find("span").html(toggleTxt);
		}
	});
}

//ページTOPへボタン
//----------------------------------------------
function scroll_pagetop() {
	var topBtn = $('.c-pagetop');
	topBtn.hide();
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			topBtn.fadeIn();
		} else {
			topBtn.fadeOut();
		}
	});
	topBtn.on('click', function () {
		$('body,html').animate({scrollTop: 0}, 500);
		return false;
	});
}


//マガジンヘッダー
//----------------------------------------------
function magazine_gnav() {

	var $win = $(window);
	var $body = $("body");
	var $headerWrap = $('#all-header-wrap');
	var $GHeader = $('.vortex-header');
	var $LHeader = $('.c-mheader');
	var $main = $('.l-main');

	//ヘッダ追従処理
	var scroll = 0;
	var GHeader_H = $GHeader.height();
	var LHeader_H = $LHeader.height();
	var allHeaderHeight = GHeader_H + LHeader_H;

	$main.css({"padding-top":allHeaderHeight});

	//スクロール監視
	function scroll_check() {
		var win_pos = $win.scrollTop();
		if(win_pos < scroll ){
			//上スクロールしたらグローバルヘッダを再表示
			$headerWrap.not(":animated").animate({top:0},100);
			$body.removeClass("is-header-scroll");
		}else{
			//ヘッダの高さを過ぎたらグローバルヘッダを非表示
			if(win_pos > allHeaderHeight * 1.0 ){
				$headerWrap.not(":animated").animate({top:-GHeader_H},100);
				$body.addClass("is-header-scroll");
			}
		}
		scroll = win_pos;
	}

	//画面幅変更の監視
	//ウインドウのリサイズ処理が終わった時だけ関数を実行する
	function header_reinit() {
		if(!$body.hasClass("fixedAll")) {
			GHeader_H = $GHeader.height();
			LHeader_H = $LHeader.height();
			allHeaderHeight = GHeader_H + LHeader_H;
			$main.css({"padding-top":allHeaderHeight});
		}
	}
	var win_timer = false;
	$win.on("resize",function() {
		if (win_timer !== false) {clearTimeout(win_timer);}
		win_timer = setTimeout(function() {
			header_reinit();
		}, 200);
	});

	$win.on("scroll",function(){
		scroll_check();
	});
	scroll_check();
	

	//アコーディオン
	function header_accordion(){
		var $magHeadInnerTrigger = $('.c-headerXS__menu--ttl');
		$magHeadInnerTrigger.children('.c-headerXS__menu--checkbox').on('click', function () {
			$(this).parent('.c-headerXS__menu--ttl').next('.c-headerXS__menu__list').toggleClass('active');
			$(this).toggleClass('active');
		});
	}
	header_accordion();


	//ハンバーガー内 キーワードもっと見るボタン
	function init_keyword_in_menu() {
		var $root = $(".c-mheader .c-sidebar__section--keyword");
		if(!$root.length || $root.hasClass("is-init")) {return false;}
		var $wrap = $root.find(".c-keyword");
		var $item = $root.find(".c-keyword__item");
		if($item.length < 10) { return false;}
		//初期高さを取得
		var full_view = $wrap.height();
		var first_view = $item.eq(8).offset().top - $item.eq(0).offset().top + $item.outerHeight(true);
		$wrap.css("height",first_view);
		$root.append('<button class="c-sidebar-keyword__more js-sidebar-keyword--more"><span class="open-text">キーワードをもっと見る</span><span class="close-text">キーワードを閉じる</span><i></i></button>');
		var $switch = $root.find(".js-sidebar-keyword--more");
		$root.addClass("is-init");
		$switch.click(function(){
			if($switch.hasClass("is-open")) {
				$wrap.animate({"height":first_view},300);
			}else {
				$wrap.animate({"height":full_view},300);
			}
			$switch.toggleClass("is-open");
		});
	}

	 //ハンバーガー
	 function hamburger(){
		var $mgHeader = $('.c-mheader--xs'),
		$mgBurger = $('.c-mheader__burger'),
		mgflag = false;
		$body.removeClass('fixedAll');
		$mgBurger.on('click', function () {
			if (!mgflag) {
				$body.addClass('fixedAll');
				$mgBurger.addClass('burger-active');
				$mgHeader.fadeIn(300, function () {
					mgflag = true;
				});
				init_keyword_in_menu();
			 } else {
				$body.removeClass('fixedAll');
				$mgBurger.removeClass('burger-active');
				$mgHeader.fadeOut(300, function () {
					mgflag = false;
				});
			}
		});
	}
	hamburger();

}


//iframeの高さ調整
//----------------------------------------------
function normalize_iframe() {
	$('.js-iframe').on('load', function () {
		try {
			$(this).height(this.contentWindow.document.documentElement.scrollHeight);
		} catch (e) {}
	}).trigger('load');
}


// TOP
// ----------------------------------------------
function top_slider() {


	//新着情報スライダー
	function latest_slider() {
		var $root = $(".u-mag-latest-slider");
		if(!$root.length) {return false;}

		//高さ揃え
		$root.on('init', function(event, slick, currentSlide, nextSlide){
			$root.find('.u-mag-card__titlegroup').heightLine();
			$root.find('.u-mag-card').heightLine();
		});
		$root.slick({
			arrows:true,
			centerMode:true,
			autoplay: false,
			autoplaySpeed: 3000,
			slidesToShow: 3,
			centerPadding:'18%',
			nextArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-next"></button>',
			prevArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-prev"></button>',
			initialSlide:1,
			responsive: [
				{
					breakpoint: 1600,
					settings: {
						centerPadding:'8%',
					}
				},
				{
					breakpoint: 1200,
					settings: {
						centerPadding:'3%'
					}
				},
				{
					breakpoint: 990,
					settings: {
						centerMode:false,
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerMode:true,
						centerPadding:'5%',
						slidesToShow: 1,
						initialSlide:0
					}
				}
			]
	  });
	}
	latest_slider();


	//ラインアップ
	function lineup_normalize() {
		var $root = $(".u-mag-lineup");
		if(!$root.length) {return false;}//SP時のみ
		//PC時のみ高さ揃え
		if(!is_range_sp() && !is_range_tab()) {
			var $list = $root.find('.u-mag-lineup-list');
			$list.find('.u-mag-card__titlegroup:eq(0)').heightLine();
			$list.find('.u-mag-card__titlegroup:eq(1)').heightLine();
			$list.find('.u-mag-card__titlegroup:eq(2)').heightLine();
			$list.find('.u-mag-card__titlegroup:eq(3)').heightLine();
		}
	}
	lineup_normalize();

	//ピックアップスライダー
	function pickup_slider() {
		var $root = $(".u-mag-pickup-slider");
		if(!$root.length ) {return false;}


		if( is_range_sp() || is_range_tab() ) {
			//高さ揃え
			$root.on('init', function(event, slick, currentSlide, nextSlide){
				$root.find('.u-mag-card__title').heightLine();
				$root.find('.u-mag-card').heightLine();
			});

			$root.slick({
				arrows:true,
				centerMode:false,
				centerPadding:'10%',
				slidesToShow: 3,
				autoplay: false,
				autoplaySpeed: 3000,
				nextArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-next"></button>',
				prevArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-prev"></button>',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							centerMode:true,
							centerPadding:'10%',
							slidesToShow: 1
						}
					}
				]
			});
		}else {
			$root.find('.u-mag-card__titlegroup').heightLine();
		}
	}
	pickup_slider();

	//著者スライダー
	function supervisor_slider() {
		var $root = $(".u-mag-supervisor-slider");
		if(!$root.length) {return false;}

		//スライダーの開始インデックス番号
		var slider_initialIndex = 1;

		//SPのみ 説明文 文字数抜粋
		//SPのみ スライダーの開始インデックスを0に
		if(is_range_sp()) {
			var slider_initialIndex = 0;
			var text_limit = 28;
			$root.find(".u-mag-supervisor__text").each(function(){
				var $text = $(this);
				var text_content = $text.text();
				if (text_content.length > text_limit) {
					$text.text(text_content.substr(0, text_limit) + '…');
				}
			});
		}

		$root.slick({
			arrows:true,
			slidesToShow: 3,
			centerMode:true,
			variableWidth:true,
			autoplay: false,
			autoplaySpeed: 3000,
			initialSlide:slider_initialIndex,
			nextArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-next"></button>',
			prevArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-prev"></button>',
			responsive: [
				{
					breakpoint: 1190,
					settings: {
						centerPadding:'5%',
						slidesToShow: 1
					}
				}
			]
		});
	}
	supervisor_slider();
}

//サイドバー
//----------------------------------------------
function magazine_sidebar() {

	//SP時 カテゴリから記事を探す
	function init_category() {
		var $root = $(".c-sidebar__container--category");
		if(!$root.length) {return false;}
		var $item = $root.find(".js-sidebar-category-acc__contents");
		if(is_range_sp()) {
			$root.find(".js-sidebar-category-acc").click(function(eo){
				eo.preventDefault();
				$(this).toggleClass("is-active");
				$item.slideToggle();
			});
		}
	}
	init_category();

	//キーワードもっと見るボタン
	function init_keyword() {
		var $root = $(".l-article__side .c-sidebar__section--keyword");
		if(!$root.length) {return false;}
		$root.each(function(){
			var $this = $(this);
			var $wrap = $this.find(".c-keyword");
			var $item = $this.find(".c-keyword__item");
			if($item.length < 10) { return false;}
			//初期高さを取得
			var full_view = $wrap.height();
			var first_view = $item.eq(8).offset().top - $item.eq(0).offset().top + $item.outerHeight(true);
			$wrap.css("height",first_view);
			$this.append('<button class="c-sidebar-keyword__more js-sidebar-keyword--more"><span class="open-text">キーワードをもっと見る</span><span class="close-text">キーワードを閉じる</span><i></i></button>');
			var $switch = $this.find(".js-sidebar-keyword--more");
			$switch.click(function(){
				if($switch.hasClass("is-open")) {
					$wrap.animate({"height":first_view},300);
				}else {
					$wrap.animate({"height":full_view},300);
				}
				$switch.toggleClass("is-open");
				setTimeout(function(){
					ScrollTrigger.refresh();
				},300);
			});
		});
	}
	init_keyword();

	//ピックアップ
	function init_pickup() {
		var $root = $(".c-sidebar-card-wrap--slider--sp");
		if(!$root.length) {return false;}
		if( is_range_sp() ) {
			//高さ揃え
			$root.on('init', function(event, slick, currentSlide, nextSlide){
				$root.find('.title-group').heightLine();
				$root.find('.c-sidebar-card').heightLine();
			});
			$root.slick({
				arrows:true,
				centerMode:true,
				centerPadding:'10%',
				slidesToShow: 1,
				autoplay: false,
				autoplaySpeed: 3000,
				nextArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-next"></button>',
				prevArrow:'<button type="button" class="u-mag__slick-pager--large u-mag__slick-prev"></button>',
			});
		}
	}
	init_pickup();

}

// 汎用 タブ切り替え
//----------------------------------------------
function tab() {
	var tabSwitchOpenClass = "is-current";
	var tabContentsOpenClass = "is-current";
	var tabParam = get_tab_param();

	// URLのパラメータ取得
	function get_tab_param() {
		var params = [];
		var param = location.search.substring(1).split('&');
		for(var i = 0; i < param.length; i++) {
			params[i] = param[i].split('=');
		}
		for(var i = 0; i < params.length; i++) {
			if(params[i][0] === 'tab' &&  params[i][1] !== undefined) {
				return params[i][1];
			}
		}
		return false;
	}
	// タブのパラメータがついている時の対応
	if($('[data-tab-content="' + tabParam + '"]').length > 0) {
		$('[data-tab-switch]').removeClass(tabSwitchOpenClass);
		$('[data-tab-switch="' + tabParam + '"]').addClass(tabSwitchOpenClass);
	}
	// 初期表示の設定
	$('[data-tab-content]').removeClass(tabContentsOpenClass);
	for (var i = 0; i < $('[data-tab-content]').length; i++) {
		var target = $('[data-tab-content]').eq(i).data('tabContent');
		if($('[data-tab-switch = ' + target + ']').hasClass(tabSwitchOpenClass)) {
			$('[data-tab-content]').eq(i).addClass(tabContentsOpenClass);
			break;
		}
	}
	// タブ切り替え
	$('[data-tab-switch]').on('click', function(e) {
		var $target = $(this).data('tabSwitch');
		$('[data-tab-switch]').removeClass(tabSwitchOpenClass);
		$('[data-tab-switch = ' + $target + ']').addClass(tabSwitchOpenClass);
		$('[data-tab-content]').removeClass(tabContentsOpenClass);
		$('[data-tab-content = ' + $target + ']').addClass(tabContentsOpenClass);
	});
}

// 月別プルダウン
//----------------------------------------------
function pull_down(){
	$(".c-pulldown__btn").on("click", function () {
		$(document).trigger("showSelect");
	});
	$(document).on("showSelect", function () {
		$(".c-pulldown__select").trigger("click");
	})
}

//目次生成
//----------------------------------------------
function init_toc() {
	$('.toc').toc({
		'container': '.u-article__content',
		'selectors': 'h2,h3',
		'scrollToOffset': 100,
		'highlightOffset': -250,
		'anchorName': function(i, heading, prefix) {
			return "anc-"+i;
		},
	});
	var $inList = $('.u-article__index.index .toc');
	if($inList.find('li').length >= 7) {
		$inList.find('li:nth-child(n+7)').addClass('is-hide-item');
		$inList.find('.is-hide-item').addClass('is-hide');
		$inList.append('<div class="top-more"><div class="top-more__bg"></div><div class="top-more__btn"><span>続きを見る</span><i class="c-icon--arrow--bottom"></i></div></div>');

		$('.top-more__btn').on('click', function() {
			if($inList.find('.is-hide-item.is-hide').length) {
				var bh = $inList.children('ul').height();
				$inList.find('.is-hide-item').removeClass('is-hide');
				var ah = $inList.children('ul').height();
				$inList.children('ul').css('height', bh)
					.animate({
						'height': ah
					}, function() {
						$(this).removeAttr('style');
					});
				$('.top-more__bg').fadeOut();
				$inList.find('.top-more__btn span').text('閉じる');
				$inList.addClass("is-open");
			} else {
				var bh = $inList.children('ul').height();
				$inList.find('.is-hide-item').addClass('is-hide');
				var ah = $inList.children('ul').height();
				$inList.find('.is-hide-item').removeClass('is-hide');
				$inList.children('ul').css('height', bh)
					.animate({
						'height': ah
					}, function() {
						$(this).removeAttr('style');
						$inList.find('.is-hide-item').addClass('is-hide');
					});
				$('.top-more__bg').fadeIn();
				$inList.find('.top-more__btn span').text('続きを見る');
				$inList.removeClass("is-open");
			}
		});
	}
	$(window).on('load', function() {
    var anchor = location.hash;
		if($('.toc').length && anchor.length) {
			if (anchor !== '') {
				window.setTimeout(function() {
					$('body, html').animate({
						scrollTop: $(anchor).offset().top - $('.c-mheader').height()
					}, 1);
				}, 10);
			}
		}
	});
}


// 汎用高さ揃え
// ----------------------------------------------
function eq_height() {
	if($('.js-matchHeight').length) {
		for (var i = 0; i < $('.js-matchHeight').length; i++) {
			var mhPoint = 1170;
			if($('.js-matchHeight').eq(i).data('matchHeightPoint') !== undefined) {
				mhPoint = $('.js-matchHeight').eq(i).data('matchHeightPoint');
			}
			$('.js-matchHeight').eq(i).find('.js-matchHeight-ttl').heightLine({
				minWidth: mhPoint
			});
		}
	}
	if($('.js-matchHeight-sp').length) {
		for (var i = 0; i < $('.js-matchHeight-sp').length; i++) {
			var mhPoint = 768;
			if($('.js-matchHeight-sp').eq(i).data('matchHeightPoint') !== undefined) {
				mhPoint = $('.js-matchHeight-sp').eq(i).data('matchHeightPoint');
			}
			$('.js-matchHeight-sp').eq(i).find('.js-matchHeight-ttl').heightLine({
				maxWidth: mhPoint
			});
		}
	}
	if($('.js-matchHeight-line').length) {
		for (var i = 0; i < $('.js-matchHeight-line').length; i++) {
			var mhPoint = 1170;
			if($('.js-matchHeight-line').eq(i).data('matchHeightPoint') !== undefined) {
				mhPoint = $('.js-matchHeight-line').eq(i).data('matchHeightPoint');
			}
			var mhChild = $('.js-matchHeight-line').eq(i).children();
			var lineLen = 0;
			if($('.js-matchHeight-line').eq(i).data('matchHeightLine') !== undefined) {
				lineLen = $('.js-matchHeight-line').eq(i).data('matchHeightLine');
			}
			for (var j = 0; j < Math.ceil(mhChild.length / lineLen); j++) {
				mhChild.slice((lineLen * j), (lineLen * (j + 1))).find('.js-matchHeight-ttl').heightLine({
					minWidth: mhPoint
				});
			}
		}
	}
}


// マガジン詳細の監修者タブ切り替え
// ----------------------------------------------
function normalize_supervisor() {
	$('.supervisor-tab').addClass('is-show');
	$('.supervisor-amp-ttl').hide();
}

// フォーム
function form_check() {
	var $checkbox11 = $('#checkbox11'),
			$checkbox12 = $('#checkbox12'),
			$checkbox13 = $('#checkbox13'),
			staffTextBox = $('#staffTextBox'),
			otherTextBox = $('#othersTextBox');

	$checkbox11.on('click', function () {
		if($checkbox11.nextAll().is(otherTextBox)) {
			otherTextBox.toggleClass('visible');
		}
	});

	$checkbox12.on('click', function () {
		staffTextBox.toggleClass('visible');
	});

	$checkbox13.on('click', function () {
		if($checkbox13.nextAll().is(otherTextBox)) {
			otherTextBox.toggleClass('visible');
		}
	});
}

function form_document() {
	var $form = $('.u-form form');
	$('.u-form__typebtn').on('click', function () {
		var documentTypeIndex = $(this).parent('.u-form__section__form__item--typeinner').index();
		$form.removeClass();
		if (documentTypeIndex == 0) {
			$form.addClass('mailing u-form__view');
		} else {
			$form.addClass('download u-form__view');
		}
	});
}


// マガジン詳細 ebook フォームスライダー
// ----------------------------------------------
function form_ebook() {
	$(".js-ebook-introbox__slider__list").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 800,
		arrows: true,
		dots: true,
		pauseOnHover: false,
		centerMode: false,
		dotsClass: 'u-ebook-introbox-dots',
		prevArrow: '<i class="is-prev u-ebook-introbox-arrow"></i>',
		nextArrow: '<i class="is-next u-ebook-introbox-arrow"></i>',
	});
}


// マガジン詳細 サイドバー追従
// ----------------------------------------------
function pinSideBarTag() {
	if (document.getElementById('sidebarBnrlist') != null) {
		if( !is_range_sp() ) {
			ScrollTrigger.create({
				trigger: "#sidebarBnrlist",
				start: "top center-=40%",
				endTrigger: ".l-article__main",
				end: "bottom 50%+=200px",
				pin: true,
				pinSpacing: false,
			});
		}
	}
}


/*--------------------------------------------------------------------------*
 * グローバルヘッダのリンクを置換
（TODO:Vシェアフォーム削除時にトルツメすること）
 *--------------------------------------------------------------------------*/
function normalize_globalheader() {
	var $elm = $("#vortexHEAD");
	if(!$elm.length) {return false;}
	$elm.find('.vortex-cta__link[href="/contact-top/document/"]').attr("href","/vshare/document/");
	$elm.find('.vortex-cta__link[href="/contact-top/contact/"]').attr("href","/vshare/contact/");
}


// ----------------------------------------------
// init
// ----------------------------------------------
$(function () {
	smooth_scroll();
	accordion();
	tab();
	scroll_pagetop();
	normalize_iframe();
	normalize_supervisor();
	normalize_globalheader();
	magazine_gnav();
	top_slider();
	eq_height();
	init_toc();
	pull_down();
	form_check();
	form_document();
	form_ebook();
});

// load
$(window).on('load', function () {
	magazine_sidebar();
	pinSideBarTag();
});

